module.exports = __webpack_public_path__ + "img/ui_zoomen_0105.74b2243f.png";